<div class="title">Réservation {{ reservationID }}</div>
<app-link-payment-pricing class="card" [total]='total' [transactionsData]='transactionsData' [opened]="false" *ngIf='init'></app-link-payment-pricing>
